module.exports = __webpack_public_path__ + "li.14595ce63412804dc56c.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/li.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/li.svg
// module chunks = styles